export const findPackageById = (packageId, options, initialPackageVariants) => {
  if (initialPackageVariants?.show_quick_variants_selection_type === 1) {
    return options.find((opt) => opt.package_id === parseInt(packageId));
  } else {
    for (const option of options || []) {
      for (const cls of option.classes || []) {
        for (const duration of cls.durations || []) {
          for (const medium of duration.mediums || [{}]) {
            for (const pkg of medium.packageInfo ||
              duration.packageInfo ||
              []) {
              if (pkg.package_id === parseInt(packageId)) {
                return pkg;
              }
            }
          }
        }
      }
    }
  }
  return null;
};
export const chunkArray = (array, size) => {
  if (!Array.isArray(array) || size <= 0) return [];
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

export const getPlainText = (html) => {
  if (!html || typeof html !== "string") return "";
  return html.replace(/<[^>]+>/g, "").trim();
};

export const togglePackage = (prevPackages, pkg, packageId) => {
  const isSelected = prevPackages.some((p) => p.package_id === packageId);
  if (isSelected) {
    return prevPackages.filter((p) => p.package_id !== packageId);
  }
  return [
    ...prevPackages,
    {
      package_id: pkg.package_id,
      package_name: pkg.package_name,
      amount: pkg.amount || "0",
      duration: pkg.duration || "",
      discount: pkg.discount || "0",
      course_id: pkg.course_id || "",
    },
  ];
};

export const formatPrice = (value) => Number(value || 0).toFixed(2);

export const isTruthyFlag = (value) =>
  value === true || value === 1 || value === "1";

export const isPackageSubscribed = (pkg = {}) => isTruthyFlag(pkg?.is_subscribe);

export const normalizeVariantOption = (option = {}) => ({
  ...option,
  amount: String(option.amount ?? "0"),
  discount: String(option.discount ?? "0"),
  is_subscribe: isTruthyFlag(option.is_subscribe),
});

export const normalizeStorePackageViewResponse = (rawData) => {
  if (!rawData || typeof rawData !== "object") return null;

  const packageDetails = rawData.package_details ?? {};
  const priceDetails = rawData.price_details ?? {};
  const variants = rawData.package_quick_variants ?? {};

  const normalizedPriceDetails = {
    ...priceDetails,
    course_price: String(
      priceDetails.course_price ??
        packageDetails.discounted_price ??
        packageDetails.amount ??
        "0.00"
    ),
    discount: String(priceDetails.discount ?? packageDetails.discount ?? "0.00"),
  };

  return {
    ...rawData,
    PackageInstallmentDetails: {
      ...packageDetails,
      is_subscribe: isTruthyFlag(packageDetails.is_subscribe),
    },
    price_details: normalizedPriceDetails,
    package_quick_variants: {
      ...variants,
      quick_variants_selection_default: variants.quick_variants_selection_default
        ? normalizeVariantOption(variants.quick_variants_selection_default)
        : null,
      quick_variants_selection_options: (
        variants.quick_variants_selection_options ?? []
      ).map(normalizeVariantOption),
    },
  };
};

export const filterValidVariantOptions = (options = [], parentPackageId = null) => {
  if (!Array.isArray(options)) return [];

  const parentId = Number(parentPackageId);
  const seen = new Set();

  return options.filter((option) => {
    const packageId = Number(option?.package_id);
    const title = String(option?.package_name || option?.title || "").trim();

    if (!Number.isFinite(packageId) || packageId <= 0) return false;
    if (!title) return false;
    if (Number.isFinite(parentId) && parentId > 0 && packageId === parentId) {
      return false;
    }
    if (seen.has(packageId)) return false;
    if (typeof option?.duration === "number") return false;

    const amount = Number(String(option?.amount ?? "").replace(/[^\d.]/g, ""));
    const displayPrice = Number(
      String(option?.price ?? "").replace(/[^\d.]/g, "")
    );
    const effectiveAmount = amount > 0 ? amount : displayPrice;

    if (!Number.isFinite(effectiveAmount) || effectiveAmount <= 0) return false;

    seen.add(packageId);
    return true;
  });
};

export const formatExpiryDate = (expiryDate) => {
  if (!expiryDate || expiryDate === "0000-00-00") return "";
  const normalized = String(expiryDate).trim().replace(" ", "T");
  const dateObj = new Date(normalized);
  if (isNaN(dateObj.getTime())) return "";
  const day = dateObj.getDate();
  const month = dateObj.getMonth() + 1;
  const year = dateObj.getFullYear();
  return `${day}-${month}-${year}`;
};
